import React from 'react';
import { lazyComponents } from '@src/utilities/LazyComponent';

AccountLandingComponent.displayName = 'theme__account-landing';
export function AccountLandingComponent({ ...props }) {
  const AccountLanding = lazyComponents['AccountLanding'];
  const { section, signUpFields, section_image, section_image_mobile, color_schemas } = props.settings;

  return (
    <AccountLanding
      settings={props.settings}
      section={section}
      signUpFields={signUpFields}
      image={section_image}
      mobileImage={section_image_mobile}
      colorSchemas={color_schemas}
    />
  );
}

AccountResetComponent.displayName = 'theme__account-reset';
export function AccountResetComponent({ ...props }) {
  const AccountReset = lazyComponents['AccountReset'];
  const { section, section_image, section_image_mobile, color_schemas } = props.settings;

  return (
    <AccountReset
      section={section}
      image={section_image}
      mobileImage={section_image_mobile}
      headerColorSchema={color_schemas.header_color_schema}
    />
  );
}

AccountActivateComponent.displayName = 'theme__account-activate';
export function AccountActivateComponent({ ...props }) {
  const AccountActivate = lazyComponents['AccountActivate'];
  const { section, section_image, section_image_mobile, color_schemas } = props.settings;

  return (
    <AccountActivate
      section={section}
      image={section_image}
      mobileImage={section_image_mobile}
      headerColorSchema={color_schemas.header_color_schema}
    />
  );
}

AccountOrdersLandingComponent.displayName = 'theme__account-orders';
export function AccountOrdersLandingComponent({ ...props }) {
  const AccountOrdersLanding = lazyComponents['AccountOrdersLanding'];

  const payload =
    props && props.settings && (props.settings.orders || props.settings.locales || props.settings.settings)
      ? props.settings
      : props || {};

  const orders = payload.orders || [];
  const locales = payload.locales || {};
  const settings = payload.settings || payload;

  return (
    <AccountOrdersLanding
      orders={orders}
      locales={locales}
      settings={settings}
    />
  );
}

AccountAddressesLandingComponent.displayName = 'theme__account-addresses';
export function AccountAddressesLandingComponent({ ...props }) {
  const AccountAddressesLanding = lazyComponents['AccountAddressesLanding'];
  const { defaultCountry, locales } = props.settings;

  return (
    <AccountAddressesLanding
      defaultCountry={defaultCountry}
      locales={locales}
    />
  );
}


AccountDetailsFormComponent.displayName = 'theme__account-details';
export function AccountDetailsFormComponent({ ...props }) {
  const AccountProfileForm = lazyComponents['AccountProfileForm'];
  const { defaultCountry, locales } = props.settings;

  return (
    <AccountProfileForm
      section={props.settings.section}
      signUpFields={[]}
    />
  );
}

AccountReturnsComponent.displayName = 'theme__account-returns';
export function AccountReturnsComponent({ ...props }) {
  const AccountReturns = lazyComponents['AccountReturns'];
  const { promoLabelConfig, locales } = props.settings;

  return (
    <AccountReturns
      promoLabelConfig={promoLabelConfig}
      locales={locales}
    />
  );
}

AccountWishlistComponent.displayName = 'theme__account-wishlist';
export function AccountWishlistComponent({ ...props }) {
  const AccountWishlist = lazyComponents['AccountWishlist'];
  const { settings, settings: { locales } } = props;

  return (
    <AccountWishlist
      settings={settings}
      locales={locales}
    />
  );
}

AccountChangePasswordComponent.displayName = 'theme__account-change-password';
export function AccountChangePasswordComponent({ ...props }) {
  const AccountChangePassword = lazyComponents['AccountChangePassword'];
  const { section } = props.settings;

  return <AccountChangePassword section={section} />;
}

AccountSidebarComponent.displayName = 'theme__account-sidebar';
export function AccountSidebarComponent({ ...props }) {
  const AccountSidebar = lazyComponents['AccountSidebar'];
  const { menu, colorSchema } = props.settings;

  return (
    <AccountSidebar
      menu={menu}
      colorSchema={colorSchema}
    />
  );
}

AccountLoginFormBlockComponent.displayName = 'theme__block-account-login-form';
export function AccountLoginFormBlockComponent({ ...props }) {
  const AccountLoginForm = lazyComponents['AccountLoginForm'];
  const { signUpFields, ...blockSettings } = props.settings;

  return (
    <AccountLoginForm
      section={blockSettings}
      blockSettings={{
        loginForm: blockSettings,
        registerCta: blockSettings,
        forgotPassword: blockSettings,
        newsletterSignup: blockSettings
      }}
    />
  );
}

AccountRegisterFormBlockComponent.displayName = 'theme__block-account-register-form';
export function AccountRegisterFormBlockComponent({ ...props }) {
  const AccountRegisterForm = lazyComponents['AccountRegisterForm'];
  const { signUpFields, ...blockSettings } = props.settings;

  return (
    <AccountRegisterForm
      section={blockSettings}
      showCustomFields={blockSettings.show_custom_fields}
      signUpFields={signUpFields || []}
    />
  );
}
